import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import Image from "next/image";
import { Col, Container, Row } from "react-bootstrap";
import styles from "./About.module.scss";
export default function AboutFAQ() {
  const $ = _c(59);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Row><Col><h1>6529 FAQ</h1></Col></Row>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <li><h3>What is 6529?</h3><p>6529 is a decentralized Network State open to anyone with an internet connection.</p><p>It is a place where people choose what to build, fund it, and make it happen.</p><p>The Memes are public-good NFTs at the core of the network. They align participants with shared values, fund public goods, distribute influence, and anchor identity and reputation.</p><p>Identity and reputation live on-chain. Decision-making power is decentralized. What people decide gets built.</p><p>Bitcoin decentralized money. Ethereum decentralized code. 6529 decentralizes coordination.</p></li>;
    t2 = <h3>How do I get started?</h3>;
    t3 = <p>Getting started is simple:</p>;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <li>Go to <a href="https://6529.io">6529.io.</a></li>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t20;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <li>{t2}{t3}<ol>{t4}<li>Connect your wallet.{" "}<a href="#what-is-a-wallet">(What is a wallet?)</a></li><li>Create your profile.</li><li>Start exploring.</li></ol><p>From there, you can chat in Waves, vote, build reputation, and participate in the network.</p></li>;
    t6 = <li><h3>What are Waves?</h3><p>Waves are the communication and decision-making channels inside Brain. They are functionally similar to Channels on Discord.</p><p>Each Wave is a space for a specific topic, group, or initiative. In Waves, you can chat with others and vote on decisions related to that topic.</p><p>Some Waves, like "Maybe's Dive Bar", are casual conversations. Others, like "The Memes - Main Stage", directly influence what gets built or funded.</p><Image unoptimized={true} src="/faq-waves-view.jpg" alt="Waves view in 6529 Brain" width={2626} height={1284} className={styles.faqImage} /></li>;
    t7 = <li><h3>What is my profile?</h3><p>Your profile is your identity in the network: it shows your user name and your profile picture. Here you can explore the activity of a user and see the reputation and participation in the community.</p><Image unoptimized={true} src="/faq-profile.jpg" alt="6529 profile view" width={2086} height={846} className={styles.faqImage} /><p>Key components:</p><dl><dt>Total Days Held (TDH)</dt><dd><ul><li>Measures how long and how many Meme Cards you have held.</li><li>Longer holding increases influence.</li><li>TDH allows each user to assign REP and NIC credits.</li></ul></dd><dt>Reputation (REP)</dt><dd><ul><li>Reflects your skills, contributions, and participation.</li><li>Used to signal trust in the network.</li></ul></dd><dt>Network Identity Credits (NIC)</dt><dd><ul><li>Represents your identity within and outside of 6529.</li><li>Helps the network understand you.</li></ul></dd></dl></li>;
    t8 = <li><h3>How does the system work overall?</h3><p>6529 runs on a simple flywheel:</p><p><strong>Memes → TDH → Reputation → Coordination</strong></p><ul><li>The Memes create culture, fund public goods, and attract aligned participants.</li><li>Holding The Memes NFTs (meme cards) builds TDH.</li><li>TDH provides credibility to reputation and identity.</li><li>Credible identity and reputation on-chain enables better coordination and effective decision-making.</li></ul><p>As this loop grows, the network becomes more powerful.</p></li>;
    t9 = <li><h3>Why do Memes matter?</h3><p>New systems need new cultures. The Memes exist to spread ideas like:</p><ul><li>Economic freedom.</li><li>Open systems.</li><li>Digital rights.</li></ul><p>The goal is not just funding public goods. The goal is cultural impact at scale.</p></li>;
    t10 = <li><h3>What are The Memes?</h3><p>The Memes are a community curated NFT collection focused on decentralization, digital rights, and open systems.</p><p>They are the starting point of the network. They serve three roles:</p><ul><li>Cultural expression.</li><li>Coordination mechanism.</li><li>Public goods funding.</li></ul><p>New Meme Cards are released three times per week, forever, and selected through community TDH voting in "The Memes - Main Stage" wave.</p></li>;
    t11 = <li><h3>Why would I collect Meme Cards?</h3><p>Collecting The Memes lets you:</p><ul><li>Earn TDH over time and build influence in the network.</li><li>Support public goods.</li><li>Own culturally meaningful art.</li></ul><p>Holding longer increases your influence and alignment with the network.</p></li>;
    t12 = <li><h3>How do Meme drops work?</h3><ul><li>Drops occur Monday, Wednesday, and Friday.</li><li>The community votes on which artwork is selected using TDH.</li><li>Mint price is 0.06529 ETH per edition.</li><li>You can mint during the drop or buy on secondary markets.</li></ul></li>;
    t13 = <li><h3>Do Meme Cards have utility?</h3><p>All the Meme Cards generate TDH which is central in the process of curating and deciding which artworks we select to mint among other governance tasks.</p><p>When you mint a Meme Card, you get the final product: an art-edited NFT. All The Memes are CC0 (public domain) and anyone can use the art freely but only those who hold the NFT generate TDH.</p></li>;
    t14 = <li><h3>How do I participate beyond collecting?</h3><p>You don't need to buy anything to participate.</p><p>You can:</p><ul><li>Join conversations in Waves.</li><li>Contribute ideas.</li><li>Help curate content.</li><li>Build tools or projects.</li><li>Coordinate with others on non-TDH votes.</li></ul><p>Over time, participation builds reputation and influence.</p></li>;
    t15 = <li><h3>What is the long-term vision?</h3><p>6529 aims for nation-scale impact. The goal is to build a global, decentralized economy the size of South Korea or NYC, where:</p><ul><li>Humans and AI coordinate global work together.</li><li>Capital and talent are allocated through reputation.</li><li>Public goods are funded at scale.</li></ul><p>This is a new model for organizing society and economic activity globally.</p></li>;
    t16 = <li><h3>How does everything fit together?</h3><ul><li>Memes create culture and fund the system.</li><li>TDH measures alignment.</li><li>REP and NIC build identity and trust.</li><li>Brain enables coordination and decisions.</li><li>Decisions trigger real-world and on-chain outcomes.</li></ul><p>6529 is a new global coordination layer for the modern economy.</p></li>;
    t17 = <h3>What are Gradients?</h3>;
    t18 = <p>6529 Gradients is an NFT collection of 101 grayscale variations of the 6529 logo, released in October 2021. No additional NFTs will ever be added.</p>;
    t19 = <p>The collection has no direct relationship to The Memes. It predates The Memes and was created as a purely conceptual project.</p>;
    t20 = <p>Gradient holders receive a 2% TDH boost. They are also included in The Memes allowlists as early supporters of the decentralization mission, and we value having them participate in the network.</p>;
    $[5] = t10;
    $[6] = t11;
    $[7] = t12;
    $[8] = t13;
    $[9] = t14;
    $[10] = t15;
    $[11] = t16;
    $[12] = t17;
    $[13] = t18;
    $[14] = t19;
    $[15] = t20;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t10 = $[5];
    t11 = $[6];
    t12 = $[7];
    t13 = $[8];
    t14 = $[9];
    t15 = $[10];
    t16 = $[11];
    t17 = $[12];
    t18 = $[13];
    t19 = $[14];
    t20 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
  }
  let t21;
  let t22;
  let t23;
  let t24;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <li>{t17}{t18}{t19}{t20}<p>Secondary market for the collection can be found here:{" "}<a href="https://opensea.io/collection/6529-gradient" target="_blank" rel="noreferrer">Gradients.</a></p></li>;
    t22 = <li><h3>What is NextGen?</h3><p>NextGen is an on-chain generative art NFT platform on Ethereum. It supports 6529's goals around art experimentation and decentralized social coordination.</p><p>NextGen uses a core smart contract (with supporting contracts) to host multiple artist collections. The generative script and seed are stored fully on-chain, and traits are randomized at mint.</p><p>There is no fixed drop schedule for new collections. Drops happen only when the work meets a high bar for quality and originality.</p></li>;
    t23 = <h3>What are ReMemes?</h3>;
    t24 = <p>ReMemes are community-created derivatives of The Memes. Anyone can make a ReMeme. No approval is needed.</p>;
    $[21] = t21;
    $[22] = t22;
    $[23] = t23;
    $[24] = t24;
  } else {
    t21 = $[21];
    t22 = $[22];
    t23 = $[23];
    t24 = $[24];
  }
  let t25;
  let t26;
  let t27;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <li>{t23}{t24}<p>Submit and explore them on the{" "}<Link href="/rememes">ReMemes platform.</Link></p></li>;
    t26 = <h3>What is the Meme Lab?</h3>;
    t27 = <p>The Meme Lab is an experimental CC0 contract for artists who have already minted a Meme Card. It lets them create and mint NFTs in any way they choose.</p>;
    $[25] = t25;
    $[26] = t26;
    $[27] = t27;
  } else {
    t25 = $[25];
    t26 = $[26];
    t27 = $[27];
  }
  let t28;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <section><ol className={styles.faqList}>{t1}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t21}{t22}{t25}<li>{t26}{t27}<p>There is no fixed drop schedule for new collections. Drops happen when ready and are announced on the{" "}<a href="https://x.com/6529collections" target="_blank" rel="noreferrer">6529collections X account.</a></p><p>The economics of each drop are determined by the artist.</p></li></ol></section>;
    $[28] = t28;
  } else {
    t28 = $[28];
  }
  let t29;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <h2>Bonus track</h2>;
    $[29] = t29;
  } else {
    t29 = $[29];
  }
  let t30;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <p>If you want to go deeper into 6529 in book form, your path is{" "}<em>Memes Outside: The Book (2nd Edition).</em> It is a living extension of everything you have read so far. The book is an interactive experience that connects the digital world of 6529 with physical space. It invites you to take art outside, play with it, interact with it, and become a co-creator. Through essays, images, and guided explorations, it shows how the concept of network art can be experienced beyond the screen. Each copy is, in a sense, a unique piece completed through your own actions.</p>;
    $[30] = t30;
  } else {
    t30 = $[30];
  }
  let t31;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <section className={styles.faqBonus}>{t29}{t30}<p>The book is CC0 and you can download it here:{" "}<a href="https://arweave.net/HRGsv6tXpKx-yUPD8j7zi8Vz8-ILZr378oNDYemST0E" target="_blank" rel="noreferrer">Memes Outside: The Book (2nd Edition).</a></p></section>;
    $[31] = t31;
  } else {
    t31 = $[31];
  }
  let t32;
  let t33;
  let t34;
  let t35;
  let t36;
  let t37;
  let t38;
  let t39;
  let t40;
  let t41;
  let t42;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <h2>What is a Wallet?</h2>;
    t33 = <h3>What is a crypto wallet?</h3>;
    t34 = <p>A crypto wallet is a tool that allows you to store, send, and receive cryptocurrency. Think of it like a digital version of your physical wallet, except instead of holding cash and cards, it holds your digital assets.</p>;
    t35 = <h3>How does it work?</h3>;
    t36 = <p>Your wallet doesn't actually store your crypto; the crypto lives on the blockchain. What your wallet stores are your private keys, which are secret codes that prove you own your assets and allow you to authorize transactions. Your wallet also has a public address (like an email address) that others can use to send you crypto.</p>;
    t37 = <h3>Types of wallets</h3>;
    t38 = <p>There are two main categories of crypto wallets: hot wallets and cold wallets. The key difference is whether the wallet is connected to the internet.</p>;
    t39 = <h3>Hot Wallets (Connected to the Internet)</h3>;
    t40 = <p>Hot wallets are software-based wallets that are always connected to the internet. They are convenient, easy to use, and free, making them ideal for everyday transactions. The tradeoff is that because they are online, they are more vulnerable to hacking or phishing attacks.</p>;
    t41 = <p>Popular Hot Wallets:</p>;
    t42 = <strong>MetaMask:</strong>;
    $[32] = t32;
    $[33] = t33;
    $[34] = t34;
    $[35] = t35;
    $[36] = t36;
    $[37] = t37;
    $[38] = t38;
    $[39] = t39;
    $[40] = t40;
    $[41] = t41;
    $[42] = t42;
  } else {
    t32 = $[32];
    t33 = $[33];
    t34 = $[34];
    t35 = $[35];
    t36 = $[36];
    t37 = $[37];
    t38 = $[38];
    t39 = $[39];
    t40 = $[40];
    t41 = $[41];
    t42 = $[42];
  }
  let t43;
  let t44;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <li>{t42} The most popular browser extension wallet for Ethereum and NFTs. Available at{" "}<a href="https://metamask.io" target="_blank" rel="noreferrer">metamask.io.</a></li>;
    t44 = <strong>Rabby Wallet:</strong>;
    $[43] = t43;
    $[44] = t44;
  } else {
    t43 = $[43];
    t44 = $[44];
  }
  let t45;
  let t46;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = <li>{t44} A browser extension wallet built for DeFi and NFT users, with built-in transaction previews and multi-chain support. Available at{" "}<a href="https://rabby.io" target="_blank" rel="noreferrer">rabby.io.</a></li>;
    t46 = <strong>Coinbase Wallet:</strong>;
    $[45] = t45;
    $[46] = t46;
  } else {
    t45 = $[45];
    t46 = $[46];
  }
  let t47;
  let t48;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = <li>{t46} A user-friendly mobile and browser wallet from Coinbase. Available at{" "}<a href="https://wallet.coinbase.com" target="_blank" rel="noreferrer">wallet.coinbase.com.</a></li>;
    t48 = <strong>Rainbow Wallet:</strong>;
    $[47] = t47;
    $[48] = t48;
  } else {
    t47 = $[47];
    t48 = $[48];
  }
  let t49;
  let t50;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t49 = <li>{t48} A mobile-first Ethereum wallet, great for NFT collectors. Available at{" "}<a href="https://rainbow.me" target="_blank" rel="noreferrer">rainbow.me.</a></li>;
    t50 = <strong>Trust Wallet:</strong>;
    $[49] = t49;
    $[50] = t50;
  } else {
    t49 = $[49];
    t50 = $[50];
  }
  let t51;
  let t52;
  let t53;
  let t54;
  let t55;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = <ul>{t43}{t45}{t47}{t49}<li>{t50} A multi-chain mobile wallet supporting hundreds of cryptocurrencies. Available at{" "}<a href="https://trustwallet.com" target="_blank" rel="noreferrer">trustwallet.com.</a></li></ul>;
    t52 = <h3>Cold Wallets (Offline Storage)</h3>;
    t53 = <p>Cold wallets are hardware or paper-based wallets that store your private keys completely offline. Because they are never connected to the internet, they are far more secure against hacking. They are best suited for storing large amounts of digital assets long-term. The tradeoff is that they cost money to purchase and are less convenient for everyday use.</p>;
    t54 = <p>Popular Cold Wallets:</p>;
    t55 = <strong>Ledger:</strong>;
    $[51] = t51;
    $[52] = t52;
    $[53] = t53;
    $[54] = t54;
    $[55] = t55;
  } else {
    t51 = $[51];
    t52 = $[52];
    t53 = $[53];
    t54 = $[54];
    t55 = $[55];
  }
  let t56;
  let t57;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t56 = <li>{t55} The most widely used hardware wallet brand, supporting thousands of cryptocurrencies. Available at{" "}<a href="https://ledger.com" target="_blank" rel="noreferrer">ledger.com. (~$79-$249)</a></li>;
    t57 = <strong>Trezor:</strong>;
    $[56] = t56;
    $[57] = t57;
  } else {
    t56 = $[56];
    t57 = $[57];
  }
  let t58;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t58 = <Container>{t0}<Row><Col className={styles.faqContainer}>{t28}{t31}<section id="what-is-a-wallet" className={styles.walletSection}>{t32}{t33}{t34}{t35}{t36}{t37}{t38}{t39}{t40}{t41}{t51}{t52}{t53}{t54}<ul>{t56}<li>{t57} An open-source hardware wallet known for its strong security model. Available at{" "}<a href="https://trezor.io" target="_blank" rel="noreferrer">trezor.io. (~$69-$219)</a></li></ul><h3>Important Security Tips</h3><ul><li>Never share your seed phrase or private key with anyone, not even support staff or developers.</li><li>Never enter your seed phrase on any website. Legitimate services will never ask for it.</li><li>Always download wallets from official websites only.</li><li>Always double-check URLs before connecting your wallet.</li><li>Consider using a separate "burner" wallet for new or untrusted platforms, keeping your main holdings in a separate wallet.</li></ul></section></Col></Row></Container>;
    $[58] = t58;
  } else {
    t58 = $[58];
  }
  return t58;
}